module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"view_all":"View {title}"},"ro":{"view_all":"Vezi {title}","Messages":"Mesaje"}}')
  delete Component.options._Ctor
}
